import * as authDuck from '../store/ducks/auth.duck';
import { CancelToken } from "axios";
import store from '../store/store';

const TIMEOUT = 300000; // 5 minutos

export class HttpService {
	constructor(axiosInstance) {
		if (!axiosInstance) {
			throw new Error("Setup do axios não fornecido");
		}

		this.axios = axiosInstance;
	}

	getAuthData() {
		const {
			auth: {
				authData
			}
		} = store.getState();
		return authData;
	}

	async makeHttpRequest(config) {
		const source = await CancelToken.source();
		config.timeout = config?.timeout ?? TIMEOUT;

		setTimeout(() => {
			source.cancel();
		}, config.timeout - 1000);

		config.cancelToken = source.token;

		try {
			const httpResponse = await this.axios.request(config);
			return config.responseType === "blob" ? httpResponse : httpResponse.data;
		} catch (e) {
			console.log(`Error on makeHttpRequest ${e} on ${config.url}`);
			if (e.response.status === 401 && e.config.url.includes("refresh")) {
				store.dispatch(authDuck.actions.logout())
				window.location.reload()
			}

			if (!e.response) {
				throw e;
			}

			return this.handleRequestError(e, config);
		}
	}

	handleRequestError(e, config) {
		if (process.env.REACT_APP_DEBUG === 'true') {
			const reponsePayload = typeof e.response.data === 'string'
				? e.response.data
				: JSON.stringify(e.response.data);

			console.error(`
        Error: ${e.message},
        StatusCode: ${e.response.status},
        Request Config: ${JSON.stringify(config)},
        Response Payload: ${reponsePayload}
      `);
		}

		throw e;
	}
}
